import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import CampaignType from '../views/CampaignType.vue';
import ContactLists from '../views/ContactLists.vue';
import Message from '../views/Message.vue';
import Campaign from '../views/Campaign.vue';
import ReviewAndSend from '../views/ReviewAndSend.vue';
import Congratulations from '../views/Congratulations.vue';
import Reports from '../views/Reports.vue';
import ListContactLists from '../views/ListContactLists.vue';
import CreateContactList from '../views/CreateContactList.vue';
import CreateCaller from '../views/CreateCaller.vue';
import EditContactList from '../views/EditContactList.vue';
import ListCaller from '../views/Caller.vue';
import MyProfile from '../views/MyProfile.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            layout: 'base'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            layout: 'no-progress',
            header: 'login'
        },
    },
    {
        path: '/message_type',
        name: 'message_type',
        component: CampaignType,
        meta: {
            pageStep: 1,
            requiresAuth: true,
            link: "/contacts_list"
        },
    },
    {
        path: '/contacts_list',
        name: 'contacts_list',
        component: ContactLists,
        meta: {
            pageStep: 2,
            requiresAuth: true,
            link: "/message"
        },
    },
    {
        path: '/message',
        name: 'message',
        meta: {
            pageStep: 3,
            requiresAuth: true,
            link: "/campaign"
        },
        component: Message,
    },
    {
        path: '/campaign/',
        name: 'campaign',
        component: Campaign,
        meta: {
            pageStep: 4,
            requiresAuth: true,
            link: "/review_and_send"
        },
    },
    {
        path: '/review_and_send',
        name: 'review_and_send',
        component: ReviewAndSend,
        meta: {
            pageStep: 5,
            requiresAuth: true,
        },
    },
    {
        path: '/congratulations',
        name: 'congratulations',
        component: Congratulations,
        meta: {
            layout: "no-progress",
            requiresAuth: true,
        },
    },
    {
        path: '/reports',
        name: 'reports',
        component: Reports,
        meta: {
            layout: "no-progress",
            requiresAuth: true,
        },
    },
    {
        path: '/contact_lists',
        name: 'contact_lists',
        component: ListContactLists,
        meta: {
            layout: "no-progress",
            requiresAuth: true,
        },
    },
    {
        path: '/contact_lists/:id/edit',
        name: 'contact_lists_edit',
        component: EditContactList,
        meta: {
            layout: "no-progress",
            requiresAuth: true,
        },
    },
    {
        path: '/callers/create',
        name: 'callers_create',
        component: CreateCaller,
        meta: {
            layout: "no-progress",
            requiresAuth: true,
        },
    },
    {
        path: '/contact_lists/create',
        name: 'contact_lists_create',
        component: CreateContactList,
        meta: {
            layout: "no-progress",
            requiresAuth: true,
        },
    },
    {
        path: '/callback_number',
        name: 'callback_number',
        component: ListCaller,
        meta: {
            layout: "no-progress",
            requiresAuth: true,
        },
    },
    {
        path: '/account',
        name: 'account',
        component: MyProfile,
        meta: {
            layout: "no-progress",
            requiresAuth: true,
        },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next()
            return
        }
        next('/login');
    } else {
        next()
    }
});

export default router;
